"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyForYourNewSignboard() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section data-section-id="237089" id="institutional-procurement" className="relative w-full overflow-hidden bg-background text-foreground py-24 md:py-32 lg:py-48 flex items-center justify-center min-h-[80vh]">
      {}
      <style dangerouslySetInnerHTML={{
      __html: `
          @keyframes float-slow {
            0%, 100% { transform: translateY(0) rotate(0deg); }
            50% { transform: translateY(-20px) rotate(2deg); }
          }
          @keyframes float-slower {
            0%, 100% { transform: translateY(0) rotate(0deg); }
            50% { transform: translateY(-30px) rotate(-2deg); }
          }
          .animate-float-slow {
            animation: float-slow 6s ease-in-out infinite;
          }
          .animate-float-slower {
            animation: float-slower 8s ease-in-out infinite;
          }
        `
    }} />

      {}
      <div className="absolute inset-0 pointer-events-none opacity-20 dark:opacity-40" style={{
      backgroundImage: `
            linear-gradient(to right, var(--border) 1px, transparent 1px),
            linear-gradient(to bottom, var(--border) 1px, transparent 1px)
          `,
      backgroundSize: "4rem 4rem",
      maskImage: "radial-gradient(ellipse at center, black 20%, transparent 70%)",
      WebkitMaskImage: "radial-gradient(ellipse at center, black 20%, transparent 70%)"
    }} />

      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px] md:w-[600px] md:h-[600px] bg-primary/10 rounded-full blur-[100px] md:blur-[150px] pointer-events-none" />

      {}
      <div className="absolute left-[-10%] md:left-[5%] top-[20%] md:top-[30%] w-64 md:w-96 opacity-30 md:opacity-60 pointer-events-none animate-float-slow">
        <div className="relative">
          <div className="absolute inset-0 bg-primary/20 blur-[60px] rounded-full" />
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655791/img/molecular_structure_gold_left.png" alt="Molecular Structure Left" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl" />
        </div>
      </div>

      {}
      <div className="absolute right-[-10%] md:right-[5%] bottom-[20%] md:bottom-[30%] w-64 md:w-96 opacity-30 md:opacity-60 pointer-events-none animate-float-slower">
        <div className="relative">
          <div className="absolute inset-0 bg-primary/10 blur-[60px] rounded-full" />
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655791/img/crystalline_helix_gold_right.png" alt="Crystalline Helix Right" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl" />
        </div>
      </div>

      {}
      <div ref={contentRef} className={`relative z-20 container mx-auto px-4 md:px-6 flex flex-col items-center text-center transition-all duration-1000 ease-out border-2 border-primary/40 p-12 md:p-20 bg-background/40 backdrop-blur-sm ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="inline-flex items-center rounded-none border border-primary/50 bg-primary/5 px-3 py-1 text-sm font-medium text-primary mb-8 backdrop-blur-sm tracking-widest uppercase">
          <span className="flex h-2 w-2 rounded-full bg-primary mr-2 animate-pulse"></span>
          Aurelian Helix Institutional
        </div>

        <h2 className="font-default text-4xl md:text-6xl lg:text-7xl font-bold tracking-tighter max-w-4xl mx-auto leading-[1.1] mb-8 text-foreground drop-shadow-lg uppercase">
          INSTITUTIONAL PROCUREMENT <br className="hidden md:block" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary via-primary/80 to-primary filter drop-shadow-[0_0_15px_rgba(var(--primary),0.3)]">
            & BULK SYNTHESIS
          </span>
        </h2>

        <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto mb-12 font-default">
          Tailored logistics and priority synthesis for research universities and private laboratories worldwide. Secure your supply chain with the Aurelian Standard.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 items-center justify-center">
          <Link to="/InstitutionalInquiryPage">
            <Button size="lg" className="h-14 px-10 text-base font-bold rounded-none bg-primary text-primary-foreground shadow-[0_0_30px_-5px_var(--primary)] hover:shadow-[0_0_45px_-5px_var(--primary)] transition-all duration-300 uppercase tracking-wider">
              Open Institutional Account
            </Button>
          </Link>
          <Link to="/ShopPage">
            <Button variant="outline" size="lg" className="h-14 px-10 text-base font-bold rounded-none bg-transparent backdrop-blur-md border-primary/50 text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300 uppercase tracking-wider">
              View Bulk Catalog
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}